import { Button, Typography } from '@montugroup/design-system';
import { Stack } from '@mui/material';

interface PrescriptionsReloadButtonProps {
  reload: () => void;
}

export const PrescriptionsReloadContent = ({ reload }: PrescriptionsReloadButtonProps) => (
  <Stack alignItems="flex-start" justifyContent="space-between" spacing={2} direction="row" useFlexGap>
    <Stack spacing={2}>
      <Typography variant="subtitle2" gutterBottom>
        <strong>New prescription details available</strong>
      </Typography>
      <Typography variant="subtitle2" gutterBottom>
        Reload to update. Your page and notes won’t be affected.
      </Typography>
    </Stack>
    <Button variant="text" onClick={reload}>
      Reload
    </Button>
  </Stack>
);
